export const ACCOUNT_DELETION_MESSAGE_PREFIX = 'Delete Drift account data for';

export const getAccountDeletionMessage = (
	authority: string,
	timestamp: number
) => {
	return `${ACCOUNT_DELETION_MESSAGE_PREFIX} ${authority} at ${timestamp}`;
};
